import React, { useState } from "react";
import OkDialog from "../Ok";
import FleetsList from "./FleetsList";

const FleetsDialog = ({ fleets, onClose, checkedFleets, single }) => {
  const [checked, setChecked] = useState([]);
  const handleClose = () => {
    onClose(checked);
  };
  const handleChange = (fleets) => {
    if (single) {
      onClose(fleets);
    } else setChecked(fleets);
  };
  return (
    <OkDialog title="انتخاب ناوگان" onClose={handleClose} ok="انتخاب" fullWidth>
      <FleetsList
        fleets={fleets}
        checkedFleets={checkedFleets}
        onChange={handleChange}
      />
    </OkDialog>
  );
};

export default React.memo(FleetsDialog);
